import defaultAriaProps from 'client/utils/constants/ariaPropTypes';
import styles from './Header.module.scss';

const Header = ({ children, ...props }) => {
    return (
        <header
            data-testid="navbar.header"
            className="govuk-header js-enabled"
            role="banner"
            data-module="govuk-header"
            {...props}
        >
            <div className={[styles.header, 'govuk-header__container govuk-header__container--full-width'].join(' ')}>
                {children}
            </div>
        </header>
    );
};

Header.propTypes = {
    ...defaultAriaProps
};

export default Header;
